import { type ComponentType, type LazyExoticComponent, lazy } from "react"

/**
 * Code-splits a page that is a named export, which is how every page here is
 * written: `lazyPage(() => import("@/routes/clients"), "ClientsPage")`.
 */
export function lazyPage<TName extends string>(
  load: () => Promise<Record<TName, ComponentType>>,
  name: TName
): LazyExoticComponent<ComponentType> {
  return lazy(async () => ({ default: (await load())[name] }))
}
